import React from 'react';

const Portfolio = () => (
  <div className="bg-white">
    <div className="max-w-screen-xl mt-0  mx-auto  px-4 sm:px-6 lg:px-8">
      <div className="mt-6 md:mb-6 grid grid-cols-2 gap-2 md:grid-cols-5 lg:mt-8">
        <div className="col-span-1 py-2 px-2">
          <img src={require('../svg/Clients/Achieva.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1 py-2 px-2">
          <img src={require('../svg/Clients/Callective.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1 py-2 px-2">
          <img src={require('../svg/Clients/columbus-medicine.png')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1 py-2 px-2">
          <img src={require('../svg/Clients/Csdap.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1 py-2 px-2">
          <img src={require('../svg/Clients/Dunedin.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Hyloq.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Knowbe4.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Kratos.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Ntc-main.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Salvation.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/sg.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Tpv-main.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/uet.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/uge.jpg')} alt="Main ConsultFGC" />
        </div>
        <div className="col-span-1  py-2 px-2">
          <img src={require('../svg/Clients/Workware.jpg')} alt="Main ConsultFGC" />
        </div>
      </div>
    </div>
  </div>
);

export default Portfolio;
